exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1j1cx7QyU_URIfYooY72nS{width:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.YeOtHt-piwI3m8fRxG3Xx{font-size:16px}", ""]);
// Exports
exports.locals = {
	"iconContainer": "_1j1cx7QyU_URIfYooY72nS",
	"icon": "YeOtHt-piwI3m8fRxG3Xx"
};